import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "svg2",
	width: 501.13333,
	height: 146.85333,
	viewBox: "0 0 501.13333 146.85333",
	"sodipodi:docname": "FIDO-Primary-RGB.eps",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs6" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview4",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g8",
			"inkscape:groupmode": "layer",
			"inkscape:label": "ink_ext_XXXXXX",
			transform: "matrix(1.3333333,0,0,-1.3333333,0,146.85333)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "g10",
				transform: "scale(0.1)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "m 1287.58,916.609 h 525.63 c 9.72,0 17.6,-7.882 17.6,-17.589 V 786.887 c 0,-9.707 -7.88,-17.59 -17.6,-17.59 h -381.18 v -156.77 h 333.84 c 9.72,0 17.6,-7.879 17.6,-17.597 V 482.809 c 0,-9.719 -7.88,-17.59 -17.6,-17.59 H 1432.03 V 197.668 c 0,-9.719 -7.88,-17.59 -17.6,-17.59 h -126.85 c -9.71,0 -17.59,7.871 -17.59,17.59 V 899.02 c 0,9.707 7.88,17.589 17.59,17.589",
						style: {
							fill: "#118ad4",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path12"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 1952.61,916.609 h 126.85 c 9.72,0 17.59,-7.882 17.59,-17.589 V 197.668 c 0,-9.719 -7.87,-17.59 -17.59,-17.59 h -126.85 c -9.71,0 -17.59,7.871 -17.59,17.59 V 899.02 c 0,9.707 7.88,17.589 17.59,17.589",
						style: {
							fill: "#118ad4",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path14"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 2228.6,899.02 c 0,9.707 7.88,17.589 17.6,17.589 h 269.65 c 231.49,0 391.41,-158.882 391.41,-366.16 v -2.109 c 0,-207.281 -159.92,-368.262 -391.41,-368.262 H 2246.2 c -9.72,0 -17.6,7.871 -17.6,17.59 z m 162.04,-128.672 v -444.02 h 125.21 c 132.57,0 222.01,89.442 222.01,219.91 v 2.102 c 0,130.469 -89.44,222.008 -222.01,222.008 h -125.21",
						style: {
							fill: "#118ad4",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path16"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 2975.72,546.238 v 2.102 c 0,209.387 165.2,380.898 392.46,380.898 227.28,0 390.37,-169.398 390.37,-378.789 v -2.109 c 0,-209.383 -165.2,-380.891 -392.47,-380.891 -227.27,0 -390.36,169.399 -390.36,378.789 m 613.43,0 v 2.102 c 0,126.269 -92.6,231.476 -223.07,231.476 -130.46,0 -220.96,-103.117 -220.96,-229.367 v -2.109 c 0,-126.262 92.59,-231.473 223.06,-231.473 130.48,0 220.97,103.102 220.97,229.371",
						style: {
							fill: "#118ad4",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path18"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 545.5,740.047 c -107.23,0 -194.551,-87.332 -194.551,-194.563 0,-17.82 2.371,-35.039 6.832,-51.379 13.207,13.961 31.039,23.461 50.938,25.989 -1.641,8.172 -2.379,16.633 -2.379,25.39 0,76.789 62.379,139.161 139.16,139.161 76.629,0 139.012,-62.372 139.012,-139.161 0,-76.629 -62.383,-139.007 -139.012,-139.007 -14.262,0 -28.219,2.226 -41.141,6.238 -4.75,-19.301 -16.187,-35.942 -31.48,-47.52 22.422,-9.058 46.93,-14.109 72.621,-14.109 107.23,0 194.41,87.18 194.41,194.398 0,107.231 -87.18,194.563 -194.41,194.563 m 0,0 c -107.23,0 -194.551,-87.332 -194.551,-194.563 0,-17.82 2.371,-35.039 6.832,-51.379 13.207,13.961 31.039,23.461 50.938,25.989 -1.641,8.172 -2.379,16.633 -2.379,25.39 0,76.789 62.379,139.161 139.16,139.161 76.629,0 139.012,-62.372 139.012,-139.161 0,-76.629 -62.383,-139.007 -139.012,-139.007 -14.262,0 -28.219,2.226 -41.141,6.238 -4.75,-19.301 -16.187,-35.942 -31.48,-47.52 22.422,-9.058 46.93,-14.109 72.621,-14.109 107.23,0 194.41,87.18 194.41,194.398 0,107.231 -87.18,194.563 -194.41,194.563 M 838.672,152.965 C 756.84,91.6211 655.398,55.2383 545.5,55.2383 c -170.352,0 -325.84,86.7387 -416.289,231.8357 -48.4102,77.531 -73.961,166.93 -73.961,258.41 0,95.352 27.4805,187.731 79.461,267.332 76.187,116.59 195.891,193.954 330,216.234 -4.609,10.54 -7.133,22.29 -7.133,34.45 0,7.29 0.891,14.27 2.672,20.95 C 309.059,1060.68 173.922,974.254 88.3711,843.113 30.6016,754.453 0,651.523 0,545.484 0,443.605 28.3711,344.105 82.1289,257.664 182.828,96.3906 355.988,0 545.5,0 669.359,0 784.02,41.5898 875.648,111.676 859.16,120.887 846.09,135.445 838.672,152.965 M 628.371,1084.89 c 1.777,-6.82 2.668,-13.96 2.668,-21.39 0,-12.16 -2.519,-23.75 -6.98,-34.14 233.019,-37.587 411.541,-240.305 411.541,-483.876 0,-102.91 -31.93,-198.558 -86.291,-277.418 17.82,-6.679 32.972,-19.312 42.769,-35.492 62.232,88.66 98.912,196.629 98.912,312.91 0,272.68 -200.939,499.316 -462.619,539.406 M 545.5,740.047 c -107.23,0 -194.551,-87.332 -194.551,-194.563 0,-17.82 2.371,-35.039 6.832,-51.379 13.207,13.961 31.039,23.461 50.938,25.989 -1.641,8.172 -2.379,16.633 -2.379,25.39 0,76.789 62.379,139.161 139.16,139.161 76.629,0 139.012,-62.372 139.012,-139.161 0,-76.629 -62.383,-139.007 -139.012,-139.007 -14.262,0 -28.219,2.226 -41.141,6.238 -4.75,-19.301 -16.187,-35.942 -31.48,-47.52 22.422,-9.058 46.93,-14.109 72.621,-14.109 107.23,0 194.41,87.18 194.41,194.398 0,107.231 -87.18,194.563 -194.41,194.563 m 0,0 c -107.23,0 -194.551,-87.332 -194.551,-194.563 0,-17.82 2.371,-35.039 6.832,-51.379 13.207,13.961 31.039,23.461 50.938,25.989 -1.641,8.172 -2.379,16.633 -2.379,25.39 0,76.789 62.379,139.161 139.16,139.161 76.629,0 139.012,-62.372 139.012,-139.161 0,-76.629 -62.383,-139.007 -139.012,-139.007 -14.262,0 -28.219,2.226 -41.141,6.238 -4.75,-19.301 -16.187,-35.942 -31.48,-47.52 22.422,-9.058 46.93,-14.109 72.621,-14.109 107.23,0 194.41,87.18 194.41,194.398 0,107.231 -87.18,194.563 -194.41,194.563 m 0,0 c -107.23,0 -194.551,-87.332 -194.551,-194.563 0,-17.82 2.371,-35.039 6.832,-51.379 13.207,13.961 31.039,23.461 50.938,25.989 -1.641,8.172 -2.379,16.633 -2.379,25.39 0,76.789 62.379,139.161 139.16,139.161 76.629,0 139.012,-62.372 139.012,-139.161 0,-76.629 -62.383,-139.007 -139.012,-139.007 -14.262,0 -28.219,2.226 -41.141,6.238 -4.75,-19.301 -16.187,-35.942 -31.48,-47.52 22.422,-9.058 46.93,-14.109 72.621,-14.109 107.23,0 194.41,87.18 194.41,194.398 0,107.231 -87.18,194.563 -194.41,194.563 m 0,0 c -107.23,0 -194.551,-87.332 -194.551,-194.563 0,-17.82 2.371,-35.039 6.832,-51.379 13.207,13.961 31.039,23.461 50.938,25.989 -1.641,8.172 -2.379,16.633 -2.379,25.39 0,76.789 62.379,139.161 139.16,139.161 76.629,0 139.012,-62.372 139.012,-139.161 0,-76.629 -62.383,-139.007 -139.012,-139.007 -14.262,0 -28.219,2.226 -41.141,6.238 -4.75,-19.301 -16.187,-35.942 -31.48,-47.52 22.422,-9.058 46.93,-14.109 72.621,-14.109 107.23,0 194.41,87.18 194.41,194.398 0,107.231 -87.18,194.563 -194.41,194.563",
						style: {
							fill: "#118ad4",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path20"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 545.5,967.125 c -232.43,0 -421.488,-189.211 -421.488,-421.633 0,-232.429 189.058,-421.488 421.488,-421.488 232.43,0 421.488,189.059 421.488,421.488 0,232.422 -189.058,421.633 -421.488,421.633 m 0,-684.801 c -145.102,0 -263.172,118.071 -263.172,263.168 0,145.102 118.07,263.172 263.172,263.172 145.102,0 263.172,-118.07 263.172,-263.172 0,-145.097 -118.07,-263.168 -263.172,-263.168",
						style: {
							fill: "#4ec5e2",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path22"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 956.145,187.125 v -0.301 c -0.153,-20.051 -15.891,-36.383 -35.79,-37.422 l -0.152,-0.148 h -1.93 c -20.937,0 -37.871,16.93 -37.871,37.871 v 1.039 c 0.59,19.75 16.043,35.789 35.641,36.828 0.742,0.153 1.492,0.153 2.23,0.153 20.942,0 37.872,-17.082 37.872,-38.02",
						style: {
							fill: "#4ec5e2",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path24"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 458.32,434.254 c 0,-20.793 -16.777,-37.723 -37.566,-37.871 h -0.301 c -20.941,0 -37.871,16.93 -37.871,37.871 0,1.629 0.148,3.269 0.289,4.75 2.383,18.719 18.27,33.117 37.582,33.117 2.52,0 5.051,-0.289 7.418,-0.738 16.492,-3.27 28.961,-17.082 30.301,-34.012 0.148,-1.039 0.148,-2.078 0.148,-3.117",
						style: {
							fill: "#4ec5e2",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "m 582.184,1063.51 c 0,-11.29 -4.899,-21.53 -12.918,-28.37 -6.68,-5.94 -15.453,-9.5 -24.953,-9.5 -9.36,0 -17.969,3.56 -24.661,9.36 -8.16,6.68 -13.207,17.07 -13.207,28.51 0,7.87 2.368,15.15 6.379,21.09 1.489,2.08 3.121,4.01 4.899,5.79 6.84,6.68 16.191,10.99 26.59,10.99 10.25,0 19.601,-4.16 26.429,-10.84 1.793,-1.78 3.422,-3.71 4.91,-5.79 4.153,-6.09 6.532,-13.37 6.532,-21.24",
						style: {
							fill: "#4ec5e2",
							fillOpacity: 1,
							fillRule: "nonzero",
							stroke: "none"
						},
						id: "path28"
					})
				]
			})
		})
	]
});
export default SvgLogoBlue;
